export default "__VITE_ASSET__e679c9ec__"